import BillDiscountView from './BillDiscountForm';

export default BillDiscountView;
